import gsap from 'gsap'

import { getTimelineParallaxOptions } from './shared'
import { Animation } from '@/types'

export const mediaTextAnimation = ({
  node,
  context,
  conditions
}: Animation) => {
  if (conditions?.isSmall) return

  const selector = context?.selector || gsap.utils.selector(node)

  /**
   * references
   */
  const media = selector('[data-motion-media]')
  const text = selector('[data-motion-text]')

  /**
   * parallax animation
   */
  const parallax = gsap
    .timeline({ ...getTimelineParallaxOptions(node) })
    .fromTo(media, { xPercent: 0 }, { xPercent: 0 })
    .fromTo(text, { x: '60px' }, { x: '20px' }, 0)

  /**
   * revert
   */
  return () => {
    parallax?.kill()
  }
}
